// eslint-disable-next-line no-console
// console.log(process.env.NODE_ENV, "process.env.NODE_ENV");
console.log(process.env, "ENV");

// const hostName = window.location.hostname;

module.exports = require("../config");
